import redirectsModel from '@/core/models/redirects';

export default function(ctx) {
    const redirect = redirectsModel.find((item) => {
        if (!item?.path) {
            return false;
        }
        const regexp = new RegExp(item?.path, 'gi');

        return ctx.route.fullPath.match(regexp);
    });

    if (typeof redirect !== 'undefined') {
        process.client && window.history.pushState(Math.random().toString(), '', window.location.href);

        redirect?.isEnglishVersion
            && ctx.redirect(redirect.code, `${redirect.redirectTo}${ctx.route.fullPath.replace('/en', '')}`);

        redirect?.replacedPathPart
            ? ctx.redirect(redirect.code, ctx.route.fullPath.replace(redirect.replacedPathPart, redirect.redirectTo))
            : ctx.redirect(redirect.code, redirect.redirectTo);
    }
}
